import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Lock, Shield } from "lucide-react";
import { getSitemapByCategory, SitemapItem } from "@/utils/sitemapGenerator";

const Sitemap: React.FC = () => {
  console.log("Sitemap component is rendering");
  
  const sitemapByCategory = getSitemapByCategory();
  
  const renderSitemapItem = (item: SitemapItem) => (
    <li key={item.path} style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '0.5rem',
      padding: '0.25rem 0'
    }}>
      <Link 
        to={item.path} 
        style={{ 
          color: '#0884E4', 
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '0.25rem'
        }}
      >
        {item.title}
        {item.isProtected && <Lock size={12} style={{ color: '#F5542D' }} />}
        {item.isAdmin && <Shield size={12} style={{ color: '#F5542D' }} />}
      </Link>
      {item.description && (
        <span style={{ 
          color: '#6B7280', 
          fontSize: '0.875rem',
          fontStyle: 'italic'
        }}>
          - {item.description}
        </span>
      )}
    </li>
  );
  
  return (
    <>
      <Helmet>
        <title>Sitemap | SaunaDip</title>
        <meta name="description" content="Complete site navigation for SaunaDip - find all pages and resources." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      
      <div style={{ backgroundColor: '#F5F5F3', minHeight: '100vh', padding: '3rem 1rem' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ marginBottom: '2rem' }}>
            <Button asChild variant="ghost" style={{ marginBottom: '1.5rem' }}>
              <Link to="/">
                <ArrowLeft size={16} />
                Back to Home
              </Link>
            </Button>
            
            <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#0C3535', marginBottom: '0.5rem' }}>Sitemap</h1>
            <p style={{ color: '#6B7280', marginBottom: '1rem' }}>Complete overview of all pages on SaunaDip</p>
            <div style={{ height: '4px', width: '6rem', background: 'linear-gradient(to right, #F5542D 0%, #0884E4 100%)', borderRadius: '9999px' }}></div>
          </div>
          
          <div style={{ 
            backgroundColor: 'white', 
            borderRadius: '0.5rem', 
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', 
            padding: '2rem',
            marginBottom: '1rem'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '0.5rem', 
              marginBottom: '1rem',
              padding: '0.5rem',
              backgroundColor: '#F3F4F6',
              borderRadius: '0.25rem'
            }}>
              <Lock size={16} style={{ color: '#F5542D' }} />
              <span style={{ fontSize: '0.875rem', color: '#6B7280' }}>
                Protected pages require authentication
              </span>
              <Shield size={16} style={{ color: '#F5542D', marginLeft: '1rem' }} />
              <span style={{ fontSize: '0.875rem', color: '#6B7280' }}>
                Admin pages require admin privileges
              </span>
            </div>
          </div>
          
          {Object.entries(sitemapByCategory).map(([category, items]) => (
            <div key={category} style={{ 
              backgroundColor: 'white', 
              borderRadius: '0.5rem', 
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', 
              padding: '2rem',
              marginBottom: '1rem'
            }}>
              <h2 style={{ 
                fontSize: '1.25rem', 
                fontWeight: '600', 
                marginBottom: '1rem', 
                color: '#0C3535', 
                borderBottom: '1px solid #E5E7EB', 
                paddingBottom: '0.5rem' 
              }}>
                {category}
              </h2>
              <ul style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
                gap: '0.5rem',
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                {items.map(renderSitemapItem)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sitemap;
